export default __webpack_public_path__ + "static/media/tesyboiler.a347a681.jpg";